import React, { useState } from "react";
import {
  Modal,
  IconButton,
  TextField,
  Button,
  Stack,
  Typography,
  Box,
  FormControlLabel,
  Checkbox,
  CircularProgress
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { SAVE_DATA_ISSUES } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { useSelector } from "react-redux";
import { BIBlue, BIGrey, BILightGrey, BIRed } from "../../assets/helpers";
import { useDispatch } from "react-redux";
import { setReportSuccess, setShowReport } from "../../redux/actions/actions";
import { English } from "../../constant/EnglishFallback";
import { db, deleteChatandMessagesFromIndexedDB } from "../../db";
import BuildIdEvent from "../../common/BuildIdEvent";

const ReportModal = () => {
  const { reportData, multiLanguageData } = useSelector((state) => state?.main);
  const dispatch = useDispatch();
  const buildIdEvent = BuildIdEvent();

  const {
    TEXT_REPORT_HEADING = English?.ReportModal?.TEXT_REPORT_HEADING,
    TEXT_THIS_DATA_IS = English?.ReportModal?.TEXT_THIS_DATA_IS,
    TEXT_SUGGESTION = English?.ReportModal?.TEXT_SUGGESTION,
    TEXT_INCORRECT_INFO = English?.ReportModal?.TEXT_INCORRECT_INFO,
    TEXT_OFFENSIVE = English?.ReportModal?.TEXT_OFFENSIVE,
    TEXT_SOMETHING_ELSE = English?.ReportModal?.TEXT_SOMETHING_ELSE,
    TEXT_COMMENTS = English?.ReportModal?.TEXT_COMMENTS,
    BUTTON_CANCEL = English?.ReportModal?.BUTTON_CANCEL,
    BUTTON_REPORT = English?.ReportModal?.BUTTON_REPORT
  } = multiLanguageData?.ReportModal || {};

  const handleClose = () => {
    setSelectedOption("");
    setReportDescription("");
    setReason({
      Suggestion: false,
      Incorrect: false,
      Offensive_Inappropriate: false,
      Something_Else: false,
      FalseClaim: false
    });
    let reportObj = {
      ...reportData,
      showReport: false
    };
    dispatch(setShowReport(reportObj));
  };

  const [reportDescription, setReportDescription] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [reason, setReason] = React.useState({
    Suggestion: false,
    Incorrect: false,
    Offensive_Inappropriate: false,
    Something_Else: false,
    FalseClaim: false
  });

  const { loginData } = useSelector((state) => state?.main);
  let userId = loginData?.userInformation?.UserId ?? 0;

  const { Suggestion, Incorrect, Offensive_Inappropriate, Something_Else, FalseClaim } = reason;

  function handleDescription(e) {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
    setReportDescription(inputValue);
  }

  const handleReportClick = async () => {
    setIsLoading(true);
    try {
      const reportObj = {
        UserId: userId,
        ReturnRecordId: false,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            RecordId: reportData?.recordId || 0,
            DataSource: reportData?.name,
            DataIncorrect: selectedOption === "Incorrect" ? true : false,
            DataOffensive: selectedOption === "Offensive_Inappropriate" ? true : false,
            DataOther: selectedOption === "Something_Else" ? true : false,
            DataSuggestion: selectedOption === "Suggestion" ? true : false,
            FalseClaim: selectedOption === "FalseClaim" ? true : false,
            DataComments: reportDescription,
            AppScreenId: reportData?.AppScreenId,
            ModifiedBy: userId
          }
        ]
      };
      let reportRes = await Postrequestcall(SAVE_DATA_ISSUES, reportObj, loginData?.accessToken);
      if (reportRes?.data?.message === "OK") {
        // Delete chat group from IndexedDB if reporting a chat (AppScreenId = 75)
        if (reportData?.AppScreenId === 75 && reportData?.recordId) {
          try {
            // Invoke SignalR event for reported chat group
            buildIdEvent
              .sendReportedChatGroup(
                userId,
                loginData?.userInformation?.DeviceId,
                reportData.recordId
              )
              .then(async () => {
                console.log("SignalR report event sent successfully");
                // await db.chats.where("chatGroupId").equals(reportData.recordId).delete();
                deleteChatandMessagesFromIndexedDB(reportData.recordId).catch((err) =>
                  console.error("Error deleting reported chat from DB:", err)
                );
                dispatch(setReportSuccess(true));
              })
              .catch((err) => {
                alert("Something went wrong while reporting the chat group.");
                console.log(err);
              });
          } catch (error) {
            console.error("Error deleting chat group from IndexedDB:", error);
          }
        } else {
          dispatch(setReportSuccess(true));
        }
        handleClose();
      } else {
        handleClose();
      }
    } catch (err) {
      handleClose();
      console.error("Error reporting data issue:", err);
    } finally {
      setIsLoading(false);
    }
  };

  function handleCheckboxChange(e) {
    if (e.target.name === "Incorrect") {
      setSelectedOption("Incorrect");
      setReason({
        Incorrect: true,
        Offensive_Inappropriate: false,
        Something_Else: false,
        Suggestion: false
      });
    } else if (e.target.name === "Offensive_Inappropriate") {
      setSelectedOption("Offensive_Inappropriate");
      setReason({
        Incorrect: false,
        Offensive_Inappropriate: true,
        Suggestion: false,
        Something_Else: false
      });
    } else if (e.target.name === "Something_Else") {
      setSelectedOption("Something_Else");
      setReason({
        Incorrect: false,
        Offensive_Inappropriate: false,
        Suggestion: false,
        Something_Else: true
      });
    } else if (e.target.name === "Suggestion") {
      setSelectedOption("Suggestion");
      setReason({
        Incorrect: false,
        Offensive_Inappropriate: false,
        Something_Else: false,
        Suggestion: true,
        FalseClaim: false
      });
    } else if (e.target.name === "FalseClaim") {
      setSelectedOption("FalseClaim");
      setReason({
        Incorrect: false,
        Offensive_Inappropriate: false,
        Something_Else: false,
        Suggestion: false,
        FalseClaim: true
      });
    }
  }

  return (
    <>
      <Modal
        open={reportData?.showReport ?? false}
        onClose={() => handleClose()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box
          sx={{
            padding: {
              xs: "10px ",
              xl: " 15px",
              lg: " 15px",
              md: " 15px",
              sm: " 15px"
            }
          }}
          className="client-modal-responsive">
          <Stack sx={{ display: "flex",  mb: 1,  justifyContent: "space-between", alignItems: "center" }}   direction={"row"}>
            <Typography variant="h6">{TEXT_REPORT_HEADING}</Typography>
            <IconButton
              size="small"
              sx={{ cursor: "pointer" }}
              color={BIGrey}
              onClick={() => handleClose()}>
              <Close />
            </IconButton>
          </Stack>
          <Stack sx={{ mb: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              {reportData?.name}
            </Typography>
          </Stack>
          <Stack>
            <Typography variant="body1">{TEXT_THIS_DATA_IS}</Typography>
          </Stack>
          <>
            <Stack direction={{ xs: "column", sm: "row" }}>
              <Stack width={"100%"}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Suggestion}
                      onChange={handleCheckboxChange}
                      name="Suggestion"
                    />
                  }
                  label={TEXT_SUGGESTION}
                />
              </Stack>
              <Stack width={"100%"}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Incorrect}
                      onChange={handleCheckboxChange}
                      name="Incorrect"
                    />
                  }
                  label={TEXT_INCORRECT_INFO}
                />
              </Stack>
            </Stack>
            <Stack direction={{ xs: "column", sm: "row" }}>
              <Stack width={"100%"}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Offensive_Inappropriate}
                      onChange={handleCheckboxChange}
                      name="Offensive_Inappropriate"
                    />
                  }
                  label={TEXT_OFFENSIVE}
                />
              </Stack>
              <Stack width={"100%"}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Something_Else}
                      onChange={handleCheckboxChange}
                      name="Something_Else"
                    />
                  }
                  label={TEXT_SOMETHING_ELSE}
                />
              </Stack>
            </Stack>
           </>

          {reportData?.isVerified && (
            <Stack direction={{ xs: "column", sm: "row" }}>
              <Stack width={"100%"}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={FalseClaim}
                      onChange={handleCheckboxChange}
                      name="FalseClaim"
                    />
                  }
                  label="False Claim"
                />
              </Stack>
            </Stack>
          )}

          <Stack sx={{ mb: 2 }}>
            <TextField
              fullWidth
              variant="outlined"
              autoFocus={true}
              slotProps={{
                input: {
                  rows: 4,
                  multiline: true,
                  inputComponent: "textarea"
                }
              }}
              minRows={5}
              placeholder={TEXT_COMMENTS}
              onChange={(e) => handleDescription(e)}
              value={reportDescription}
            />
          </Stack>
          <Stack sx={{ display: "flex",  mb: 1,  justifyContent: "space-between", alignItems: "center" }}   direction={"row"}>
            <Button variant="outlined" color="primary" onClick={() => handleClose()}>
              {BUTTON_CANCEL}
            </Button>

            <Button
              variant="contained"
              style={{
                background: !(reportDescription.trim() !== "" && selectedOption !== "")
                  ? BILightGrey // Grey background when disabled
                  : isLoading
                    ? BILightGrey
                    : BIRed,
                color: !(reportDescription.trim() !== "" && selectedOption !== "")
                  ? "#FFFFFF" // White text for disabled
                  : isLoading
                    ? BIBlue
                    : "white"
              }}
              disabled={!(reportDescription.trim() !== "" && selectedOption !== "")}
              onClick={() => handleReportClick()}>
              {isLoading ? <CircularProgress size={24} color="inherit" /> : BUTTON_REPORT}
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default ReportModal;
